import Users from './container/index.js';

export default Users;


// WEBPACK FOOTER //
// ./src/views/Setup/Users/index.js